import * as React from 'react';
import {
    Box,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { ItemCreatRequest, ItemListResponse } from 'types/product/product-item';

const getNoAdsList = [
    { label: '1 Month', value: 1 },
    { label: '2 Month', value: 2 },
    { label: '1 Years', value: 12 },
];

interface Props {
    control?: Control<ItemCreatRequest>;
    errors: FieldErrors<ItemCreatRequest>;
    data?: ItemListResponse;
}
const ItemNoAds: React.FC<Props> = (props: Props) => {
    const { control, data, errors } = props;

    const initialNoAds = data?.itemValue?.period ?? '';

    return (
        <Box>
            <FormControl
                error={Boolean(errors?.itemValue?.period)}
                sx={{ width: '50%' }}
            >
                <InputLabel>Price No Ads</InputLabel>
                <Controller
                    name="itemValue.period"
                    control={control}
                    rules={{
                        required: 'Price No Ads is required',
                    }}
                    render={({ field }) => (
                        <Select
                            label="Price No Ads"
                            {...field}
                            value={field.value ?? (initialNoAds || '')}
                        >
                            {getNoAdsList?.map((category) => (
                                <MenuItem
                                    key={category.value.toString()}
                                    value={category.value.toString()}
                                >
                                    {category.label}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                />
                {errors?.itemValue?.period && (
                    <FormHelperText>
                        {errors?.itemValue?.period.message?.toString()}
                    </FormHelperText>
                )}
            </FormControl>
        </Box>
    );
};

export default ItemNoAds;
